import { createReducer } from '@reduxjs/toolkit';
import { ArticleDto } from '../../api/ClientApi';

import { saveArticle, importArticles } from '../actions/articleActions';

export interface ArticlesState {
    articles: ArticleDto[] | null;
}

export const articlesReducer = createReducer<ArticlesState>({ articles: null }, (builder) => {
    builder
        .addCase(saveArticle.fulfilled, (state: ArticlesState, action: any) => {
            if (state.articles === null) {
                return;
            }

            const payload: ArticleDto = action.payload;

            const article: ArticleDto = new ArticleDto();
            article.init(payload);

            const articleIndex = state.articles!.findIndex((a) => {
                return a.id === article.id;
            });

            if (articleIndex >= 0) {
                // update article
                state.articles.splice(articleIndex, 1, article);
            } else {
                // add article
                state.articles.unshift(article);
            }
        })
        .addCase(importArticles.fulfilled, (state: ArticlesState, action: any) => {
            const currArticles = action.payload as ArticleDto[];

            state.articles = currArticles.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
        });
});
